import { GenericBackendResponse } from '../../genericBackendResponse';

export interface HoldedTokenOutputDto {
	id: string;
	companyId: string;
	holdedCompanyId: string;
	holdedApiKey: string;
	active: boolean;
	createdAt: string;
	updatedAt: string;
	lastCheckedAt: string;
}

export const getHoldedApiKey = async (
	token: string,
	companyId: string
): Promise<GenericBackendResponse<HoldedTokenOutputDto>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/holded/api-key/${companyId}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);
	return response.json();
};
